
class SlickSlider extends HTMLElement {
  connectedCallback() {
    if (!this.classList.contains("slider")) {
      this.classList.add("slider");
    }

    const userOptions = this._getSlickOptions();

    const defaultArrows = {
      prevArrow: `
        <button type="button" class="slick-prev" aria-label="Previous">
          <span class="custom-arrow">
            <svg style="transform: rotate(180deg);" xmlns="http://www.w3.org/2000/svg" width="12.264" height="21.699" viewBox="0 0 12.264 21.699">
              <path fill="none" stroke="#fff" stroke-width="2" d="M-74,254.8l10.142,10.142L-74,275.084" transform="translate(74.707 -254.092)"/>
            </svg>
          </span>
        </button>
      `,
      nextArrow: `
        <button type="button" class="slick-next" aria-label="Next">
          <span class="custom-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="12.264" height="21.699" viewBox="0 0 12.264 21.699">
              <path fill="none" stroke="#fff" stroke-width="2" d="M-74,254.8l10.142,10.142L-74,275.084" transform="translate(74.707 -254.092)"/>
            </svg>
          </span>
        </button>
      `,
    };

    // Merge defaults with user options
    const options = {
      ...defaultArrows,
      ...userOptions, // overrides arrows if provided
    };

    $(this).slick(options);
  }

  _getSlickOptions() {
    const options = this.dataset.options;
    if (!options) return {};

    try {
      return JSON.parse(options);
    } catch (e) {
      console.warn(`Invalid JSON in slick-slider ${this}:`, e);
      return {};
    }
  }
}

customElements.define("slick-slider", SlickSlider);